import paths from "@ingka/icons-shared/paths/visibility-hide";
import { renderPaths } from "../renderPaths.mjs";
var visibility_hide_default = () => renderPaths(paths);
export {
  visibility_hide_default as default
};
